import React from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import styles from '../../index.module.scss';

interface CreateRoleEntryCardProps {
  onClick: () => void;
  disabled?: boolean;
}

/**
 * 网格首位固定的"创建角色"入口卡片。
 *
 * @param props 见 CreateRoleEntryCardProps
 * @returns 入口卡节点
 */
function CreateRoleEntryCard({ onClick, disabled }: CreateRoleEntryCardProps): React.ReactElement {
  const languageStore = useLanguageStore((state) => state.languageStore);
  return (
    <button
      type="button"
      className={styles.mediaLibraryCreateRoleCard}
      onClick={onClick}
      disabled={disabled}
      aria-label="创建角色"
    >
      <div className={styles.mediaLibraryCreateRolePreview}>
        <IconFont name="plusBold" fontSize={24} color="currentColor" />
      </div>
      <div className={styles.mediaLibraryCardText}>
        <div className={styles.mediaLibraryCardTitle}>{languageStore.smartcatTranslationText((value) => value.create)}</div>
      </div>
    </button>
  );
}

export default CreateRoleEntryCard;
